require('./ProgramHeader_Simple.scss');

const b = require('app/www/libs/b')('program-header');

const React = require('react');
const PropTypes = require('prop-types');
const ProgramHeader = require('app/www/components/blocks/ProgramHeader/ProgramHeader');
const ProgramMeta = require('app/www/components/blocks/ProgramMeta/ProgramMeta');

const ProgramHeader_Simple = (props) => {
    const {
        age,
        type,
        title,
        eventId,
        programId,
        channelsId,
        isFavorite,
        ottSelection,
        episodesLength,
        isLayoutColumnsSmall,
        onClickButtonTrailer,
        onClickButtonEpisodes,
        buttonBroadcastingProps,
        onClickButtonWatchOnline,
        onClickButtonBroadcasting,
        onClickButtonWatchEpisode,
    } = props;

    const programMetaProps = {age, type: type.name};

    const programHeaderProps = {
        type,
        title,
        eventId,
        programId,
        channelsId,
        isFavorite,
        ottSelection,
        episodesLength,
        isLayoutColumnsSmall,
        onClickButtonTrailer,
        onClickButtonEpisodes,
        buttonBroadcastingProps,
        onClickButtonWatchOnline,
        onClickButtonBroadcasting,
        onClickButtonWatchEpisode,
    };

    return (
        <div className={b({simple: true})}>
            {(type || age) && (
                <div className={b('meta')}>
                    <ProgramMeta {...programMetaProps} />
                </div>
            )}
            <ProgramHeader {...programHeaderProps} />
        </div>
    );
};

ProgramHeader_Simple.propTypes = {
    age: PropTypes.number,
    type: PropTypes.object,
    title: PropTypes.string,
    programId: PropTypes.number,
    isFavorite: PropTypes.bool,
    ottSelection: PropTypes.object,
    episodesLength: PropTypes.number,
    isLayoutColumnsSmall: PropTypes.bool,
    onClickButtonTrailer: PropTypes.func,
    onClickButtonEpisodes: PropTypes.func,
    onClickButtonWatchOnline: PropTypes.func,
    onClickButtonBroadcasting: PropTypes.func,
    onClickButtonWatchEpisode: PropTypes.func,
    buttonBroadcastingProps: PropTypes.object,
};

module.exports = ProgramHeader_Simple;
